import { WorkflowEditorService } from 'api-clients/monolith';
import { useApiService } from 'hooks';
import React from 'react';

export function useRejectionReasons() {
  const fetchRejectionReasons = React.useCallback(
    () => WorkflowEditorService.getInternalApiWorkflowEditorRejectionReasons(),
    [],
  );

  return useApiService(fetchRejectionReasons);
}
